<template>
  <div class="home2">
    <h2>采购 热值分类统计</h2>
    <el-form :inline="true">
      <el-form-item label="采购日期">
        <el-date-picker v-model="searchParam.dates" type="daterange" start-placeholder="起" end-placeholder="止" style="width: 220px;" @change="commitFindList()" />
      </el-form-item>
    </el-form>
    <el-table :data="data.list" border show-summary :summary-method="summary">
      <el-table-column prop="productHeatType" label="类型" width="100" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.productHeatType === 'HIGH'">高卡</el-text>
          <el-text v-if="scope.row.productHeatType === 'MEDIUM'">中卡</el-text>
          <el-text v-if="scope.row.productHeatType === 'LOW'">低卡</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="sendQuantity" label="采购数量" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.sendQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productPrice" label="煤矿单价" show-overflow-tooltip align="right" width="160">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.productPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transportPrice" label="运费单价" show-overflow-tooltip align="right" width="160">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.transportPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productAmount" label="煤矿总价" show-overflow-tooltip align="right" width="160">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.productAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transportSendAmount" label="总运费" show-overflow-tooltip align="right" width="160">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.transportSendAmount) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 4px;" />

    <h2>库存 热值分类统计</h2>
    <el-form :inline="true">
      <el-form-item label="仓储">
        <el-select v-model="searchParam2.storage" filterable style="width: 120px;" clearable @change="commitFindList2()">
          <el-option v-for='storageItem in show2.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-switch v-model="searchParam2.hasStorage" active-text="区分仓储" @change="commitFindList2()" />
      </el-form-item>
      <el-form-item label="库存数据刷新时间">
        <el-text v-if="data2 && data2.now">{{ util.parseTime(data2.now) }}</el-text>
      </el-form-item>
    </el-form>
    <el-table :data="data2.list" border show-summary :summary-method="summary2">
      <el-table-column prop="storage" label="仓储" width="100" show-overflow-tooltip v-if="show2.tableStorage" />
      <el-table-column prop="productHeatType" label="类型" width="100" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.productHeatType === 'HIGH'">高卡</el-text>
          <el-text v-if="scope.row.productHeatType === 'MEDIUM'">中卡</el-text>
          <el-text v-if="scope.row.productHeatType === 'LOW'">低卡</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="库存数量" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.quantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="percentage" label="占比" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ scope.row.percentage + '%' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productPrice" label="煤矿单价" show-overflow-tooltip align="right" width="160">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.productPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transportPrice" label="运输单价含调度费" show-overflow-tooltip align="right" width="180">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.transportPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productAmount" label="煤矿总价" show-overflow-tooltip align="right" width="160">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.productAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transportSendAmount" label="总运费" show-overflow-tooltip align="right" width="160">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.transportSendAmount) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 4px;" />

    <h2>销售利润测算</h2>
    <el-form :inline="true">
      <el-form-item label="测算区间">
        <el-date-picker v-model="searchParam3.dates" type="daterange" start-placeholder="起" end-placeholder="止" style="width: 220px;" @change="commitFindList3()" />
      </el-form-item>
    </el-form>
    <div class="table3">
      <table class="table" style="text-align: center;" v-if="data3.profitCalculation && data3.profitCalculation.detailList">
        <!-- <tr>
        <td></td>
        <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
          <el-text v-if="detail.profitCalculationType == 'procure'">采购测算</el-text>
          <el-text v-if="detail.profitCalculationType == 'sale'">销售测算</el-text>
        </td>
      </tr> -->
        <tr>
          <td></td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <template v-if="detail.profitCalculationType == 'procure'">
              <el-text v-if="detail.productHeatType == 'HIGH'">高卡</el-text>
              <el-text v-if="detail.productHeatType == 'MEDIUM'">中卡</el-text>
              <el-text v-if="detail.productHeatType == 'LOW'">低卡</el-text>
            </template>
            <template v-if="detail.profitCalculationType == 'sale'">
              <el-text>{{ detail.custom }}</el-text>
            </template>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>合同价</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.contractPrice) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>热值</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.rezhi) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>硫</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.liu) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>调价累计</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.adjustmentAmount) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <div style="height: 2px;"></div>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>结算价</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.settlementPrice) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>煤本</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.productPrice) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>上游运费</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.upstreamTransportPrice) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>下游运费</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.downstreamTransportPrice) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>调度费</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.dispatchPrice) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>费用</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.costAmount) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <div style="height: 2px;"></div>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>业务测算利润</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.businessProfit) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <div style="height: 2px;"></div>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>税前利润</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.beforeTaxProfit) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <div style="height: 2px;"></div>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>净利润</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.netProfit) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>数量</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.quantity) }}
            </el-text>
          </td>
        </tr>
        <tr>
          <td>
            <el-text>利润金额</el-text>
          </td>
          <td v-for="(detail, index) in data3.profitCalculation.detailList" :key="index">
            <el-text style="width: 100%; text-align: center;">
              {{ math.formatNumber(detail.profitAmount) }}
            </el-text>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import util from '../../utils/util'
import math from '../../utils/math'

// 
// 页面1
//
const data = reactive({
  list: [],
  productQuantity: null,
  productAmount: null,
  payAmount: null,
  invoiceQuantity: null,
  invoiceAmount: null,
})

const now = new Date()
const yesterday = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000)
const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.dates = [yesterday, yesterday]
}
resetSearchParam()

const commitFindList = () => {
  data.list = []
  const params = {}
  if (searchParam.dates && searchParam.dates.length == 2) {
    params.dateGe = util.parseTime(searchParam.dates[0], '{y}-{m}-{d}')
    params.dateLe = util.parseTime(searchParam.dates[1], '{y}-{m}-{d}')
  } else {
    ElMessage.error('请选择时间')
    return
  }
  api.get('/backend/statistics/procureHeatType', { params: params }).then(res => {
    data.list = res.list
    data.sendQuantity = res.sendQuantity
    data.transportSendAmount = res.transportSendAmount
    data.productAmount = res.productAmount
    data.transportPrice = res.transportPrice
    data.productPrice = res.productPrice
  })
}
commitFindList()

const summary = () => {
  return [
    '合计',
    math.formatNumber(data.sendQuantity),
    math.formatNumber(data.productPrice),
    math.formatNumber(data.transportPrice),
    math.formatNumber(data.productAmount),
    math.formatNumber(data.transportSendAmount),
  ]
}

// 
// 页面2
//
const data2 = reactive({
  list: [],
  quantity: null,
  transportPrice: null,
  productPrice: null,
  transportSendAmount: null,
  productAmount: null,
})

const show2 = reactive({
  storageList: [],
  tableStorage: true,
})

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show2.storageList = res.dictList
})
const searchParam2 = reactive({})
const resetSearchParam2 = () => {
  searchParam2.storage = null
  searchParam2.hasStorage = true
}
resetSearchParam2()

const commitFindList2 = () => {
  data2.list = []
  const params = {
    storage: searchParam2.storage,
    hasStorage: searchParam2.hasStorage
  }
  api.get('/backend/statistics/inventoryHeatType', { params: params }).then(res => {
    data2.list = res.list
    data2.quantity = res.quantity
    data2.transportPrice = res.transportPrice
    data2.productPrice = res.productPrice
    data2.transportSendAmount = res.transportSendAmount
    data2.productAmount = res.productAmount
    data2.now = res.now
    if (searchParam2.hasStorage) {
      show2.tableStorage = true
    } else {
      show2.tableStorage = false
    }
  })
}
commitFindList2()

const summary2 = () => {
  const summary = []
  summary.push('合计')
  if (show2.tableStorage) {
    summary.push('')
  }
  summary.push(math.formatNumber(data2.quantity))
  summary.push('')
  summary.push(math.formatNumber(data2.productPrice))
  summary.push(math.formatNumber(data2.transportPrice))
  summary.push(math.formatNumber(data2.productAmount))
  summary.push(math.formatNumber(data2.transportSendAmount))
  return summary
}

// 
// 页面3
//
const data3 = reactive({
  list: [],
  quantity: null,
  transportPrice: null,
  productPrice: null,
  transportSendAmount: null,
  productAmount: null,
})

const show3 = reactive({
})

const searchParam3 = reactive({})
const resetSearchParam3 = () => {
  searchParam3.storage = null
  searchParam3.hasStorage = true
}
resetSearchParam3()

const commitFindList3 = () => {
  data3.profitCalculation = {}
  const params = {}
  if (searchParam3.dates && searchParam3.dates.length == 2) {
    params.beginDate = util.parseTime(searchParam3.dates[0], '{y}-{m}-{d}')
    params.endDate = util.parseTime(searchParam3.dates[1], '{y}-{m}-{d}')
  } else {
    ElMessage.error('请选择时间')
    return
  }
  api.get('/backend/profitCalculation/getOneByDate', { params: params }).then(res => {
    res.detailList = res.detailList.filter(item => item.profitCalculationType == 'sale')
    data3.profitCalculation = res
  })
}
</script>

<style lang="less">
.home2 {
  margin: auto;

  .table3 {
    table {
      width: 100%;
      margin: 0;
      border-collapse: collapse;
    }

    table,
    th,
    td {
      border: 1px solid #ddd;
    }
  }
}
</style>